import React from "react";

function PricingSection() {
  const pricingPlans = [
    {
      name: "Starter",
      price: "$9.99",
      features: [
        { name: "Support", available: true },
        { name: "Free Updates", available: true },
        { name: "Custom Domain", available: true },
        { name: "Ultimate Storage", available: false },
        { name: "12 Add-Ons", available: false }
      ],
      highlighted: false
    },
    {
      name: "Starter",
      price: "$9.99",
      features: [
        { name: "Support", available: true },
        { name: "Free Updates", available: true },
        { name: "Custom Domain", available: true },
        { name: "Ultimate Storage", available: true },
        { name: "12 Add-Ons", available: false }
      ],
      highlighted: true
    },
    {
      name: "Growth",
      price: "$19.99",
      features: [
        { name: "Support", available: true },
        { name: "Free Updates", available: true },
        { name: "Custom Domain", available: true },
        { name: "Unlimited Storage", available: true },
        { name: "12 Add-Ons", available: true }
      ],
      highlighted: false
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-center text-4xl font-bold mb-12 text-gray-900">
          Pricing
        </h2>

        <div className="flex flex-wrap justify-center gap-8">
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={`w-full sm:w-1/2 lg:w-1/4 max-w-sm border rounded-lg shadow-md flex flex-col ${
                plan.highlighted
                  ? "border-2 border-[rgba(10,192,171,1)] transform scale-105"
                  : "border-gray-200"
              }`}
            >
              <div className="p-6 text-center">
                <h4 className="text-sm font-semibold text-[rgba(10,192,171,1)] mb-2 uppercase">
                  {plan.name}
                </h4>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                  {plan.price}
                  <span className="text-base font-normal text-gray-600">
                    /Month
                  </span>
                </h1>

                <ul className="text-left mb-6 w-full">
                  {plan.features.map((feature, i) => (
                    <li
                      key={i}
                      className={`flex items-center justify-between py-4 border-b`}
                    >
                      <div className="flex items-center">
                        {feature.available ? (
                          <svg
                            className="w-4 h-4 text-[rgba(10,192,171,1)] mr-2 flex-shrink-0"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 13.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        ) : (
                          <svg
                            className="w-4 h-4 text-gray-400 mr-2 flex-shrink-0"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        )}
                        <p
                          className={`text-sm ${
                            feature.available
                              ? "text-gray-700"
                              : "text-gray-400 line-through"
                          }`}
                          style={{
                            fontFamily: "inherit" // Change this to desired font-family
                          }}
                        >
                          {feature.name}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>

                <button
                  className="w-full py-3 px-6 font-semibold transition"
                  style={{
                    backgroundColor: plan.highlighted
                      ? "rgba(10, 192, 171, 1)"
                      : "transparent",
                    color: plan.highlighted ? "#fff" : "rgb(0,0,0)",
                    borderWidth: "1px",
                    borderColor: "rgba(10, 192, 171, 1)",
                    borderRadius: "0px"
                  }}
                >
                  Get Started
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PricingSection;
